import React from 'react';
import NavBarLeft from './../../ReusableComp/NavBarLeft';
import NavigationBar from '../../ReusableComp/NavigationBar';
import { useEffect, useState } from 'react';
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import { getPiList, getAllSites, getAllStudies } from '../../../Redux/actions/actions';
import axios from 'axios';
import { TOGGLE_NO, TOGGLE_YES, base_url } from '../../../utilities';
import { useNavigate } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { ModalFooter } from 'react-bootstrap';
import PopUpModal from '../../ReusableComp/PopUpModal';
import Loader from '../../ReusableComp/Loader';

const PIstudysiteMapping = () => {

    const dispatch= useDispatch()
    const navigate = useNavigate();
    const[mapedStudy,setMapedStudy] =useState([])

    const piList = useSelector((state) => (state.piList));
    const allSites = useSelector((state) => (state.getAllSites));
    const getStudiesMaster = useSelector((state) => (state.getStudiesData));
    const getStudies = getStudiesMaster?.filter(item => !mapedStudy?.some(i => item.study_id === i.value)); 
    
    const [selectedPi, setSelectedPi] = useState();
    const [piDetails, setPiDetails] = useState()
    const [selectedSite, setSelectedSite] = useState(piDetails?.pi_sites);
    const [siteDetails, setSiteDetails] = useState()
    const [selectedStudy, setSelectedStudy] = useState()
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = useState(false);

useEffect(() => {
   
  const convertedData = piDetails?.pi_studies?.map(item => ({
      value: item.study_id,
      label: `${item.study_name}`
    }));
    setMapedStudy(convertedData)

}, [piDetails?.pi_studies]);
    useEffect(() => {
    dispatch(getPiList())
    dispatch(getAllSites())
    dispatch(getAllStudies())
 }, [dispatch])
 
  const options = piList?.map(i => ({
    value: i.pi_id,
    label: i.name
  }));

  const siteoptions = allSites?.map(i => ({
    value: i.site_id,
    label: i.site_name
  }));

let studyIds = selectedStudy?.map(i => i?.value)
let mapObject = {
  "pi_id": selectedPi?.value,
    "user_id": piDetails?.user_id,
    "is_site_mapped_to_pi":piDetails?.pi_sites?.site_id ? TOGGLE_YES :TOGGLE_NO,
    "site_id": selectedSite?.value ? selectedSite?.value:piDetails?.pi_sites?.site_id,
    "studies":studyIds||[]
}

  const handleSelectedPi = selectedOption => {
    setSelectedPi(selectedOption);
    setSelectedSite()
    setSiteDetails()
   let selectedPI =  piList?.filter(i => i.pi_id === selectedOption.value)
   setPiDetails(selectedPI[0])
  };
  
  const handleSelectedSite = selectedOption => {
    setSelectedSite(selectedOption);

   let selectedSite =  allSites?.filter(i => i.site_id === selectedOption.value)
   setSiteDetails(selectedSite[0])
  };
const handleStudySelect = (selected)=>{
    setSelectedStudy(selected)
}

const handleMap =(e)=>{
  setLoading(true)
    axios
        .post(
          base_url + "principal-investigator/map_pi_to_site_study",
          mapObject
        )
        .then((res) => {
          if(res.data.message =="Mapped successfully"){
            setLoading(false)
            setTimeout(() =>{
              setOpen(true)
            },200)
          }else{
            alert("Some thing went wrong!")
          }
        })
        .catch((error) => {
          console.log(error);
        });
    
     

}
const handleClosePopup = () => {
  setOpen(false);
   
};
const handleDone=()=>{
  window.location.reload()
  setOpen(false);
  setTimeout(() =>{
    navigate('/pistudysitemapping')
  },200)
  
}
    return (
        <div>
        <NavigationBar 
        studyDropdwn={true}
        title={"Site and Study Mapping"}/>
        <div className='main_body p-3 pb-0  gap-3 flex-column contentmain'  >
          
        <Row className=' border rounded'>
          <Col md={4} className='p-0  '>
            <LeftContent
            navigate={navigate}
            handleMap={handleMap}
            handleSelectedSite={handleSelectedSite}
            handleSelectedPi={handleSelectedPi}
            selectedSite={selectedSite}
            piDetails={piDetails}
            selectedPi={selectedPi}
            siteoptions={siteoptions}
            options={options}
            getStudies={getStudies}
            selectedStudy={selectedStudy}
            handleStudySelect={handleStudySelect}
            />
          </Col>
          <Col className='px-3 mt-2'>
          <RightContent siteDetails={siteDetails} piDetails={piDetails}/>
          </Col>
        </Row>

          {piDetails &&
            <div>
              <div>

                <div className="row gap-3">
                  

             
                </div>

                {/* {piDetails?.pi_sites.site_name !== null ? */}

                 

              </div>
              
            </div>



          }


        </div>
        <PopUpModal
        handleClose={handleClosePopup}
        open={open}
        title={"Success!"}
        msg={"Mapped successfully!"}
        close={"Close"}
        actionbtn={"Done"}
        onConfirm={handleDone}
      />
      {loading && <Loader />}
        </div>
    );
};

export default PIstudysiteMapping;

const RightContent=({piDetails,siteDetails })=>{  

  return(
    <div >
      {piDetails &&
        <div className='row'>
            <div className="  col">
              <p className='mb-2'><b>Principal Investigator Details</b></p>
               <div className="right_cntnt_card" >
              <p className='img'> <img src="./images/icons/user_sm.svg" alt="" /> {piDetails.name}</p>
              <p className='img'> <img src="./images/icons/Phone_sm.svg" alt="" /> {piDetails.contact_number}</p>
              <p className='img'> <img src="./images/icons/Mail_sm.svg" alt="" /> {piDetails.email}</p>
              <p className='img'> <img src="./images/icons/registration_sm.svg" alt="" /> {piDetails.mci_registration_number}</p>
              <p className='img'><img src="./images/icons/flag_sm.svg" alt="" /> {piDetails.nationality}</p>
              {piDetails.address && <div className='d-flex'>
                <div><img src="./images/icons/location_sm.svg" alt="" /></div>
                &nbsp;   <div className=" gap-1">
                  <ul >
                    {piDetails.address&&<p className='mb-0'>  {piDetails.address}</p>}
                    {piDetails.city && <p className='mb-0'>  {piDetails.city}</p>}
                    {piDetails.district&&<p className='mb-0'>  {piDetails.district}</p>}
                    {piDetails.state&&<p className='mb-0'>  {piDetails.state}</p>}
                    {piDetails.pin_code&&<p className='mb-0'>  {piDetails.pin_code}</p>}
                  </ul>
                </div>
              </div>}
                        </div>
            </div>
          
          
         {<div className=' col'>
          {!siteDetails &&  piDetails?.pi_sites.site_id && <div >
          <p className='mb-2'><b>Site Details </b></p>
                    <div className="right_cntnt_card">
                      <p className='img'><img src="./images/icons/Zone.png" alt="" />  {piDetails?.pi_sites.zone_name} Zone</p>
                      <p className='img'><img src="./images/icons/State_bhavan.svg" alt="" />  {piDetails?.pi_sites.state_name}</p>
                      <p className='img'><img src="./images/icons/city_sm.svg" alt="" />  {piDetails?.pi_sites.city_name}</p>
                      <p className='img'><img src="./images/icons/site_sm.svg" alt="" />  {piDetails?.pi_sites.site_name}</p>
                      <p className='img'> <img src="./images/icons/Phone_sm.svg" alt="" /> {piDetails?.pi_sites.phone_number} </p>
                      <div className='d-flex gap-3'>
                        <div className=' '> <img src="./images/icons/location_sm.svg" alt="" />  </div>
                        <ul className='ps-0'> 
                          { <p className='mb-0'>{piDetails?.pi_sites.site_address}</p>}
                          {  <p className='mb-0'>{piDetails?.pi_sites.location}</p>}
                          { <p className='mb-0'>{piDetails?.pi_sites.pincode}</p>}
                        </ul>
                    </div>
                    </div>
                  </div>}
          {siteDetails && <div className="">
          <p className='mb-2'><b>Site Details </b></p>
                    <div className='right_cntnt_card'>
                      <p className='img'><img src="./images/icons/Zone.png" alt="" />  {siteDetails.zone_name} Zone</p>
                      <p className='img'><img src="./images/icons/State_bhavan.svg" alt="" />  {siteDetails.state_name}</p>
                      <p className='img'><img src="./images/icons/city_sm.svg" alt="" />  {siteDetails.city_name}</p>
                      <p className='img'><img src="./images/icons/site_sm.svg" alt="" />  {siteDetails.site_name}</p>
                      <p className='img'> <img src="./images/icons/Phone_sm.svg" alt="" /> {siteDetails.phone_number} </p>
                      <div className='d-flex gap-3'>
                        <div className=' '> <img src="./images/icons/location_sm.svg" alt="" />  </div>
                        <ul className='ps-0'>
                          { <p className='mb-0'>{siteDetails.site_address}</p>}
                          {  <p className='mb-0'>{siteDetails.location}</p>}
                          { <p className='mb-0'>{siteDetails.pincode}</p>}
                        </ul>
                    </div>
                    </div>
                  </div>}
                   
                
          </div>}
          
        </div>}

    </div>
  )

}


const LeftContent = ({handleMap, navigate, piDetails, handleStudySelect, selectedStudy, getStudies, siteoptions, handleSelectedSite, selectedSite, options, selectedPi, handleSelectedPi}) => {


  return (
    <div className='leftContentmain' >
      <div className='child1'>
        <h6 className='mb-0'>Mapping</h6>
      </div>
      <div className="child2">
        <div>
          <label htmlFor="piStudy">Select PI<span className="text-danger">*</span></label>
          <Select
            options={options}
            value={selectedPi}
            onChange={handleSelectedPi}
            className='  w-100'
            placeholder="Select Principal Investigator"
          />
        </div>
        <div>
          <label htmlFor="piStudy">Select SIte<span className="text-danger">*</span></label>
          <Select
            options={siteoptions}
            value={!selectedSite ?( piDetails?.pi_sites?.site_id && {"label":piDetails?.pi_sites?.site_name, "value":piDetails?.pi_sites?.site_id}) : selectedSite}
            onChange={handleSelectedSite}
            className='w-100'
            placeholder="Select Site"
          />
        </div>
        <div>
          <label htmlFor="piStudy">Select Study</label>
          <Select
            id="piStudy"
            isMulti
            options={getStudies?.map((i) => ({
              value: i.study_id,
              label: i.study_name,
            }))}
            value={selectedStudy}
            className='w-100'
            onChange={handleStudySelect}
            placeholder="Select Study from the options"
          />
        </div>
      {piDetails?.pi_studies && <div  className='pimapstdlist '>
        <label className='mb-2'>Mapped Study</label>
        {piDetails?.pi_studies?.length >= 1 ? (
          <ul>
            {piDetails.pi_studies.map((item) => (
              <li key={item.study_id}>{item.study_name}</li>
            ))}
          </ul>
        ) : (
          <p>No mapped study</p>
        )}

        
      </div>}

      </div>
      <ModalFooter className='d-flex justify-content-between  px-3 py-2'>
        <button className='white_btn' onClick={() => window.location.reload()}>Cancel</button>
        <button className='orange_btn px-4' disabled={!(selectedPi?.value && (selectedSite?.value ? selectedSite?.value:piDetails?.pi_sites?.site_id))} onClick={handleMap}>Map</button>
      </ModalFooter>     


      
    </div>
  );
};
